const getToken = () => {
  const token = localStorage.getItem("token");
  return token ? JSON.parse(token) : [];
};
export const fetchGet = async (tbl) => {
  try {
    const jwtToken = getToken();
    const response = await fetch("/api/", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Connection: "keep-alive",
        Authorization: `Bearer ${jwtToken}`,
      },
      body: JSON.stringify({ action: "GetAllData", tbl: tbl }),
      // credentials: "include",
    });
    if (!response.ok) {
      throw new Error(
        `HTTP error! status: ${response.status} - ${response.statusText}`
      );
    }
    const data = await response.json();
    return data.data;
  } catch (error) {
    console.error("Error fetching data:", error);
    console.error(`Error message: ${error.message}`);
  }
};
export const fetchGetByID = async (tbl, valFLD, valID) => {
  try {
    const jwtToken = getToken();
    const response = await fetch("/api/", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Connection: "keep-alive",
        Authorization: `Bearer ${jwtToken}`,
      },
      body: JSON.stringify({
        action: "GetDataByID",
        tbl: tbl,
        valFLD: valFLD,
        valID: valID,
      }),
      // credentials: "include",
    });
    // if (!response.ok) {
    // 	throw new Error(`HTTP error! status: ${response.status} - ${response.statusText}`);
    // }
    const data = await response.json();
    return data.data;
  } catch (error) {
    console.error("Error fetching data:", error);
    console.error(`Error message: ${error.message}`);
  }
};
